import VAvatar from './VAvatar'

export { VAvatar }
export default VAvatar



// WEBPACK FOOTER //
// ../../../src/components/VAvatar/index.ts